
@if (ds_models.length) {
    <mat-tree #tree="matTree" [dataSource]="ds_models" [childrenAccessor]="childrenAccessor" class="w-100">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding class="text-color-primary">
            @if (node.type === "view") {
                <mat-icon class="me-1 cursor-pointer">description</mat-icon>
                    <div class="view-container justify-content-between align-items-center">
                        <span class="mt-1 mb-0 cursor-pointer">
                            {{node.name}}
                        </span>
                        <button mat-icon-button [matMenuTriggerFor]="menu" (click)="onModel(node)">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                    </div>
            }@else{
                <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name" [disabled]="true">
                    <mat-icon class="text-color-disabled">{{ tree.isExpanded(node) ? 'expand_more' : 'chevron_right'
                        }}</mat-icon>
                </button>
                <mat-icon class="me-1 text-color-disabled">folder</mat-icon>
                <span class="mt-1 text-color-disabled">{{ node.name }}</span>
                @if (edit_mode) {
                    <button mat-icon-button [matMenuTriggerFor]="branchMenu" (click)="selectBranch(node)">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                }
            }
        </mat-tree-node>

        <mat-tree-node *matTreeNodeDef="let node; when: hasChild">
            <div matTreeNodePadding class="d-flex align-items-center">
                <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                    <mat-icon class="cursor-pointer">{{ tree.isExpanded(node) ? 'expand_more' : 'chevron_right' }}</mat-icon>
                </button>
                <mat-icon class="me-1">folder</mat-icon>
                <span class="mt-1 text-color-primary cursor-pointer">{{ node.name }}</span>
                @if (edit_mode) {
                    <button mat-icon-button [matMenuTriggerFor]="branchMenu" (click)="selectBranch(node)">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                }
            </div>
            <div [style.display]="tree.isExpanded(node) ? 'block' : 'none'">
                <ng-container matTreeNodeOutlet></ng-container>
            </div>
        </mat-tree-node>
    </mat-tree>
}@else {
    <h5>No Model Tree Found</h5>
}